import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { FILTERS_CUSTOM_COLOR_PICKER } from '~/constants/localStorageKeys';
import { type CustomHexSlice, createCustomHexSlice } from './slices/createCustomHexSlice';

export type CustomColorPickerState = CustomHexSlice;

export const useCustomColorPickerStore = create<CustomColorPickerState>()(
  persist(
    (...args) => ({
      ...createCustomHexSlice({ hexes: [] })(...args),
    }),
    {
      name: FILTERS_CUSTOM_COLOR_PICKER,
      partialize: (state) => ({
        hexes: state.hexes,
      }),
      version: 1,
    },
  ),
);
